import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { SpaceFragment, PageInfoFragment } from '../fragments'
import { IEdge, IPageInfo, ISpace } from '@api/types'
import handleFetchResult from '@utils/handleFetchResult'

interface SpaceSearchConnection {
  pageInfo: IPageInfo
  edges: IEdge<ISpace>[]
}

interface IPayload {
  viewer: {
    company: {
      spaceConnection: SpaceSearchConnection
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, SpaceSearchConnection>({
  handler: (data) => data.viewer.company.spaceConnection,
  name: 'Space Search',
})

export const spaceSearchQuery = gql`
  query SpaceSearch($where: SpaceWhereInput, $after: String) {
    viewer {
      company {
        spaceConnection(orderBy: externalId_ASC, first: 7, where: $where, after: $after) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...SpaceFragment
            }
          }
        }
      }
    }
  }
  ${SpaceFragment}
  ${PageInfoFragment}
`

export default function spacesSearch({
  query,
  after,
  floorId,
  spaceTypeIds,
  usageTypeIds,
}: {
  query: string
  after?: string
  floorId?: string
  spaceTypeIds?: string[]
  usageTypeIds?: string[]
}): Promise<SpaceSearchConnection> {
  const variables = {
    where: {
      ...(floorId || spaceTypeIds?.length || usageTypeIds?.length
        ? {
            AND: [
              ...(floorId ? [{ floorId: floorId }] : []),
              {
                OR: [{ externalId_contains: query }, { name_contains: query }],
              },
              ...(spaceTypeIds?.length ? [{ spaceTypeId_in: spaceTypeIds }] : []),
              ...(usageTypeIds?.length ? [{ usageTypeId_in: usageTypeIds }] : []),
            ],
          }
        : { OR: [{ externalId_contains: query }, { name_contains: query }] }),
    },
    after,
  }

  return client.gql.query({ query: spaceSearchQuery, variables }).then(mutateHandler)
}
